import { Link } from "react-router-dom";
import { useConsent } from "@/lib/consent";

export default function CookieBanner() {
  const { consent, accept, decline } = useConsent();

  if (consent !== null) return null;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-50 bg-[#0B0B0B] border-t border-[#2A2A2A]"
      role="dialog"
      aria-label="Cookie consent"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between">
        <p className="text-[#9A8F83] font-mono text-[0.65rem] tracking-[0.14em] uppercase leading-relaxed max-w-xl">
          We use analytics cookies (PostHog) and advertising cookies (Google AdSense) — no cross-site tracking beyond these providers.{" "}
          <Link to="/cookies" className="text-[#CC1A1A] hover:underline">
            Cookie Policy
          </Link>
        </p>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={accept}
            className="btn-rd !py-2 !px-5 !text-[0.65rem]"
          >
            Accept →
          </button>
          <button
            onClick={decline}
            className="border border-[#2A2A2A] text-[#9A8F83] hover:text-white hover:border-[#555] px-5 py-2 text-[0.65rem] font-mono uppercase tracking-wider transition-colors"
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
}
